

const restPropWarn = false;

// type: string = 'Main',
//	restProp: $$restProps,
// base: object { id: 'Id', class: { prefix|postfix: true, value: 'string string2' } },
// required: array = ['title']
const restProp = ( _args ) =>
{

	if ( restPropWarn && !_args?.type ) return console.warn( `The components' restprop type is required`, _args.restProp );
	if ( restPropWarn && !Array.isArray( _args?.required ?? [] ) ) return console.warn( `The restprop required type is not an array`, _args.restProp );

	
	// Handle restProp map
	Object.entries( _args.restProp ).forEach( ( [ key, value ] ) => 
	{

		if ( typeof _args?.base[ key ] === 'object' )
		{
			if ( _args.base[ key ]?.prefix === true ) _args.restProp[ key ] = `${ _args.base[ key ].value } ${ value } `;
			if ( _args.base[ key ]?.postfix === true ) _args.restProp[ key ] = `${ value } ${ _args.base[ key ].value }`;	
		}

		 _args.restProp[ key ] = ( typeof _args.restProp[ key ] === 'string' ) ? _args.restProp[ key ]?.trim() : _args.restProp[ key ];

	});


	// Handle required detect;
	if ( Array.isArray( _args?.required ) && _args.required.length > 0 )
	{
		let propKeyList = `,${ Object.keys( _args.restProp ).join(',') }`.replace(/\s/g);
		_args?.required.forEach( ( key ) => 
		{
			if ( restPropWarn && !propKeyList.includes( `,${ key }` ) ) console.warn( `The required prop ${ key } is missing`, _args.restProp );
		});
	}


	// Handle bases;
	Object.entries( _args.base ).forEach( ( [ key, value ] ) => 
	{
		if ( !_args.restProp[ key ] ) _args.restProp[ key ] = value?.value ?? '';
	});


	return _args.restProp;

}

export {
	restProp,
}